import { HEADLINE_TIME_PERIOD } from '../constants';

const isHeadlineTime = (time: number) => {
  const serverTime = new Date(time);

  const hours = serverTime.getUTCHours();
  const minutes = serverTime.getUTCMinutes();

  const currentMinutes = hours * 60 + minutes;

  const startMinutes =
    HEADLINE_TIME_PERIOD.startHour * 60 + HEADLINE_TIME_PERIOD.startMinute;

  const endMinutes =
    HEADLINE_TIME_PERIOD.endHour * 60 + HEADLINE_TIME_PERIOD.endMinute;

  return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
};

export { isHeadlineTime };
